import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Category } from '../../../../common/types';
import type { State } from '../../types';

export const updateCategorySuccess =
	(updatedCategory: Category) =>
	async ({ setState, getState }: StoreActionApi<State>) => {
		setState({
			...getState(),
			categoriesData: {
				...getState().categoriesData,
				categories: getState().categoriesData.categories.map((category) =>
					category.id === updatedCategory.id ? updatedCategory : category,
				),
			},
		});
	};
